
 <app-table-title [title]="'COMMUNICATION' | dictionary"></app-table-title>

 <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0px;">

       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;">
         <div class="form-row col-lg-12 pt-2 pb-2 align-items-end" style="padding-left: 0;padding-right: 0;">
           <div class="col-md-6 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'FUND' | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="fund" (ngModelChange)="search()">
                 <option *ngFor="let fund of funds" [value]="fund.FundId">{{fund.Title}}</option>
               </select>
             </div>
           </div>

           <div class="col-sm-12" [ngClass]="{'col-md-3': daysToGoBack === 'DR', 'col-md-4': daysToGoBack !== 'DR'}">
             <label class="text-right text-color-1 filter-label-width">
               {{'TIME_FRAME' | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="daysToGoBack" (ngModelChange)="search()">
                 <option *ngFor="let timeF of timeFilters" [value]="timeF.Days">{{timeF.Text}}</option>
               </select>
             </div>
           </div>

           <div class="col-md-3 col-sm-12 d-flex gap-4" *ngIf="daysToGoBack =='DR'" style="padding-right: 0;">

             <div *ngIf="daysToGoBack =='DR'" class="flex-grow-1">
               <DateChooser width="100%" #txtFromDistDate (AfterDateSelection)="search()"
                 NullDateLabel="(None)">
               </DateChooser>
             </div>
             <div *ngIf="daysToGoBack =='DR'" class="flex-grow-1">
               <DateChooser width="100%" #txtToDistDate (AfterDateSelection)="search()"
                 NullDateLabel="(None)">
               </DateChooser>
             </div>
           </div>

         </div>
       </div>

       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;">
         <div class="form-row col-lg-12" style="padding-left: 0;padding-right: 0;">
           <div class="col-md-6 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{'MESSAGE' | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <input type="text" class="form-control" [(ngModel)]="messageSearchText" (ngModelChange)="onTextChanged()"/>
             </div>
           </div>
           <div class="col-md-4 col-sm-12">
             <label class="text-right text-color-1 filter-label-width">{{"TYPE" | dictionary}}</label>
             <div style="padding: 0px;width: calc(100% - 100px);float: left;">
               <select class="form-control" [(ngModel)]="fileType" (ngModelChange)="search()">
                 <option *ngFor="let fileT of fileTypeList" [value]="fileT.FileSubCode">{{fileT.FileSubCodeDesc}}
                 </option>
               </select>
             </div>


           </div>
         </div>
       </div>

       <!-- All and Unread tab link  -->
       <div class="pl-2 pr-2 home-middle-header-bgcolor" style="display: flex;">
         <div class="form-row col-lg-12 pb-2">

           <div style="width: 100px;float:left;">
             <div class="d-flex flex-row">
               <span style="cursor: pointer;" class="tablink text-color-1" (click)="selectInboxTypeLink('all')">
                 <div [class.tablink-border-color]="forWhat!='unread'"
                   class="w3-half tablink w3-bottombar underline-color w3-hover-light-grey w3-padding">{{'ALL' | dictionary}}</div>
               </span>
               <span style="cursor: pointer;" class="tablink text-color-1" (click)="selectInboxTypeLink('unread')">
                 <div [class.tablink-border-color]="forWhat=='unread'"
                   class="w3-half tablink w3-bottombar underline-color w3-hover-light-grey w3-padding">{{'UNREAD' | dictionary}}</div>
               </span>
             </div>
           </div>

         </div>
       </div>
       <!-- Ends  -->
     </div>
   </div>
 </div>

 <div class="row column-container">
   <div class="col-lg-12 column-container">
     <div class="m-portlet m-portlet--unair column-container" style="margin-bottom: 0px;">
       <div class="m-portlet__body form-box pl-0 pr-0 pt-0 pb-0 text-color-deep-heading column-container">
         <div class="row col-lg-12 pr-0 pl-0 mr-0 ml-0 column-container">
           <div class="col-lg-12 pl-0 pr-0 column-container">
             <kendo-grid #kendoGridComponent
                         class="column-container"
                         [data]="inbox"
                         [loading]="loading"
                         [height]="heightOfGridContainer"
                         [navigable]="true"
                         [sortable]="{allowUnsort: false, mode: 'single'}"
                         [sort]="sort"
                         (sortChange)="sortChange($event)"
                         (scrollBottom)="loadMore($event)"
                         [rowClass]="rowCallback">
               <kendo-grid-column [headerClass]="'gridheader text-color-1'"
                                  [class]="{'codeColumn': true}"
                                  field="Label"
                                  [width]="60"
                                  title="{{'MESSAGE' | dictionary}}"></kendo-grid-column>
               <kendo-grid-column [headerClass]="'gridheader  text-color-1'"
                                  [class]="{'codeColumn': true}"
                                  field="ActiveOn"
                                  title="{{'RECEIVED' | dictionary}}"
                                  [width]="20">
                 <ng-template kendoGridCellTemplate let-dataItem>
                   <div>{{ dataItem.ActiveOn | date: "MM/dd/yyyy" }}</div>
                 </ng-template>
               </kendo-grid-column>
               <kendo-grid-column [headerClass]="'gridheader  text-color-1'"
                                  [class]="{'codeColumn': true}"
                                  field="DocSeqNum"
                                  title="{{'DOWNLOAD' | dictionary}}"
                                  [width]="20"
                                  align="center"
                                  [sortable]="false">
                 <ng-template kendoGridCellTemplate let-dataItem>

                   <div class="download-icon" *ngIf="dataItem.DocSeqNum != 0" (click)="downloadDocument(dataItem.DocSeqNum,dataItem.FileNum)">
                     <i class="fas fa-file-download icon"></i>
                   </div>

                 </ng-template>
               </kendo-grid-column>
             </kendo-grid>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>
